// extracted by mini-css-extract-plugin
export var createdDate = "_ji-1";
export var divider = "_ji-2";
export var headerDivider = "_ji-3";
export var messagesCard = "_ji-0";
export var messagesContainer = "_ji-7";
export var messagesContainerWrapper = "_ji-4";
export var pointerCapturingButtonBoxes = "_ji-a";
export var showLeftPanelButton = "_ji-9";
export var showMoreButton = "_ji-c";
export var showMoreButtonContainer = "_ji-b";
export var summaryTitle = "_ji-6";
export var systemMessageCardWrapper = "_ji-d";
export var topButtons = "_ji-8";
export var withPadding = "_ji-5";